import React from 'react'

const SearchIcon = props => (
  <svg width={24.6} height={25.6} {...props}>
    <style>
      {`.st0{fill:none;stroke:#373332;stroke-width:3;stroke-miterlimit:10}`}
    </style>
    <circle className="st0" cx={14.1} cy={10.5} r={9} />
    <path className="st0" d="M1.1 24.5l7-7" />
  </svg>
)

export default SearchIcon
